export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (err: any) => {
    const { $sentry } = useNuxtApp();
    $sentry.captureException(err);
    showError({ fatal: true, statusCode: err?.statusCode || 500, data: err });
  });
});
